import { Text, Flex, Select, FormControl, InputGroup } from "@chakra-ui/react";

const FormikSelect = ({
  formik,
  label,
  name = "",
  placeholder,
  labelColor,
  labelSize,
  icon,
  inputStyle,
  style,
  children,
  onChangeCapture,
  disabled,
  // infoCircle,
  // infoIconClick,
}) => {
  return (
    <FormControl style={style}>
      <Flex gap={2} alignItems={"center"} marginBottom={2}>
        <Text
          color={labelColor ? labelColor : "#000000"}
          fontFamily={"PlusJakartaSansMedium"}
          fontSize={labelSize ? labelSize : 12}
          textTransform={"capitalize"}
        >
          {label}
        </Text>
        {/* {infoCircle && (
          <Image
            src={require("assets/svgs/info-circle.svg").default}
            width={"16px"}
            height={"16px"}
            pos={"relative"}
            _hover={{
              cursor: "pointer",
            }}
            onClick={infoIconClick}
          />
        )} */}
      </Flex>

      <InputGroup>
        <Select
          name={name}
          value={formik && formik?.values[name]}
          onChange={formik && formik?.handleChange}
          onChangeCapture={onChangeCapture}
          placeholder={placeholder}
          icon={icon}
          style={inputStyle}
          height={"48px"}
          bg={"transparent"}
          fontFamily={"PlusJakartaSansRegular"}
          borderRadius={"4px"}
          fontSize={"12px"}
          color={"#000000"}
          _placeholder={{ color: "#898989" }}
          disabled={disabled}
        >
          {children}
        </Select>
      </InputGroup>
      {formik && formik?.touched[name] && formik?.errors[name] ? (
        <Text color="#800" fontSize="10px">
          {formik?.errors[name]}
        </Text>
      ) : null}
    </FormControl>
  );
};

export default FormikSelect;
